import React, { useEffect, useState, useRef } from 'react';
import { useUser } from '../UserContext';
import CardUpdateForm from './CradUpdateForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useLocation } from "react-router-dom";
import Master from '../partials/master';
import Loader from '../Loader';
import CancelSubscriptionReviews from './CancelSubscriptionReviews';
import { CheckCircle } from '@mui/icons-material';

const SubscriptionContent = () => {
  const token = localStorage.getItem("token");
  const subscriptionData = useUser();
  const facilitydata = subscriptionData.user?.facility;
  const agreementId = facilitydata?.businessagreement?.id ?? null;
  const residentSubscription = subscriptionData.subscription;
  const staffSubscription = subscriptionData.subscriptionStaff;
  const trainingSubscription = subscriptionData.subscriptionTraining;
  const masterSubscription = subscriptionData.subscriptionMaster;
  const cacheBuster = Date.now();
  const [showModal, setShowModal] = useState(false);
  const [subscriptionToCancel, setSubscriptionToCancel] = useState(null);
  const [showCardModal, setShowCardModal] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const facilityId = subscriptionData.user?.facility?.id;
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const session_id = queryParams.get("session_id");
  const old_subscription_id = queryParams.get("old_subscription_id");
  const facilityData = subscriptionData?.user?.facility;
  const finalFacilityId = facilityData?.id;
  const [isUpdated, setIsUpdated] = useState(false);
  const [hasReloaded, setHasReloaded] = useState(false); // New state to track reload
  const hasUpdatedRef = useRef(false);
  const [loading, setLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [cancelProcessModal, setCancelProcessModal] = useState(false)

  // ✅ Checkout के बाद Subscription Update
  useEffect(() => {
    if (session_id && old_subscription_id && finalFacilityId && !isUpdated) {
      hasUpdatedRef.current = true;
      updateSubscription(session_id, old_subscription_id, finalFacilityId);
    }
  }, [session_id, old_subscription_id, finalFacilityId, isUpdated]);



  const updateSubscription = async (session_id, old_subscription_id, facility_id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/stripe/update-subscription/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({
          session_id,
          old_subscription_id,
          facility_id
        }),
      });

      if (!response.ok) {
        throw new Error("Subscription update failed.");
      }

      const data = await response.json();

      // ✅ Update UI State
      setIsUpdated(true);

    } catch (error) {
      toast.error("Subscription Update Error:", error);
    }
  };

  // useEffect(() => {
  //   if (isUpdated && !hasReloaded) {
  //     setHasReloaded(true);

  //     setTimeout(() => {
  //       // ✅ Remove query parameters from the URL
  //       navigate("/facility-subscription", { replace: true });
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 500);
  //     }, 1000); // Delay to ensure UI updates
  //   }
  // }, [isUpdated, hasReloaded, navigate]);


  // Extract plan_ids from subscriptions
  const residentPlanId = subscriptionData.subscription?.billing_interval?.id; // Plan ID for resident subscription
  const staffPlanId = subscriptionData.subscriptionStaff?.billing_interval?.id; // Plan ID for staff subscription
  const trainingPlanId = subscriptionData.subscriptionTraining?.billing_interval?.id; // Plan ID for training subscription (if exists)

  const STRIPE_CHECKOUT_KEY = process.env.REACT_APP_STRIPE_CHECKOUT_KEY;
  const [stripePromise] = useState(() =>
    loadStripe(STRIPE_CHECKOUT_KEY).catch((err) => {
      console.warn("Stripe failed to load (likely ad-blocker).", err);
      return null;
    })
  );
  const [planId, setPlanId] = useState(null);

  if (!subscriptionData) {
    toast.error("Failed to fetch subscription data");
  }

  // Destructure billing_interval from resident and staff subscriptions
  const { id: resident, billing_interval: residentBillingInterval, status: residentStatus, current_period_end: residentCurrentPeriodEnd, stripe_id: residentSubscriptionsId } = residentSubscription || {};
  const { id: staff, billing_interval: staffBillingInterval, status: staffStatus, current_period_end: staffCurrentPeriodEnd, trial_end: staffTrialPeriodEnd, stripe_id: staffSubscriptionsId } = staffSubscription || {};
  const { id: training, billing_interval: trainingBillingInterval, status: trainingStatus, current_period_end: trainingCurrentPeriodEnd, stripe_id: trainingSubscriptionsId } = trainingSubscription || {};
  const { id: master, billing_interval: masterBillingInterval, status: masterStatus, current_period_end: masterCurrentPeriodEnd } = masterSubscription || {};

  const getStatusDetails = (status) => {
    switch (status) {
      case 'active':
        return { label: 'Active', className: 'active-status bg-green-200 text-green-700 rounded-full' };
      case 'trialing':
        return { label: 'Trial Period', className: 'btn trailing-status' };
      case 'canceled':
        return { label: 'Canceled', className: 'btn canceled-status' };
      case 'pending_cancel':
        return { label: 'Pending Cancellation', className: 'btn pending-cancel-status' };
      case 'past_due':
        return { label: 'Past Due', className: 'btn past-due-status' };
      default:
        return { label: '', className: ' btn unknown-status' };
    }
  };

  const cancelSubscription = (subscriptionId) => {
    setSubscriptionToCancel(subscriptionId); // Set the subscription ID to cancel
    setShowModal(true); // Show the confirmation modal
  };

  const closeModal = () => {
    setShowModal(false);
    setSubscriptionToCancel(null); // Reset the subscription ID
  };

  // API Call to Get Subscription ID
  const fetchSubscriptionId = async (planId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/subscriptions/by-plan/${facilityId}/${planId}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch Subscription ID");

      const data = await response.json();
      setSubscriptionId(data?.subscription_id); // Save Subscription ID

      const subscriptionId = data?.susbcritpion_id;

      if (subscriptionId) {
        UpdatePaymentMethod(subscriptionId);
      }

      // setShowCardModal(true); // Open Modal
    } catch (err) {
      toast.error("Something went wrong, Please try again later");
      navigate('/error');
    }
  };

  const UpdatePaymentMethod = async (subscriptionId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/stripe/create-billing-portal/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({
          subscription_id: subscriptionId,
          // subscription_id: 'sub_1QAbmjBpwlZ9HCfmPNvd3gvo',
        })
      });

      if (!response.ok) throw new Error("Something went wrong, Please try again later.");

      const data = await response.json();

      window.location.href = data?.billing_url;
      console.log(data?.billing_url, 'fhadjgkhadsj')

      // setShowCardModal(true); // Open Modal
    } catch (err) {
      toast.error("Something went wrong, Please try again later");
      navigate('/error');
    }
  };


  const handleChangeCardDetails = (subscriptionID) => {
    // Call the fetchSubscriptionId function with the planId
    UpdatePaymentMethod(subscriptionID);
    // Set the subscriptionId to state for use in the modal
    // setSubscriptionId(subscriptionId);
  };

  const confirmCancelSubscription = async () => {
    setLoading(true)
    const url = `${process.env.REACT_APP_API_BASE_URL}/delete-subscription/${subscriptionToCancel}/`;
    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("token");
          setLoading(false)
        } else {
          toast.error(`Error: ${response.status} ${response.statusText}`);
          setLoading(false)
        }
        return; // Exit if the request fails
      }
      setLoading(false)
      toast.success("Subscription cancelled successfully!");
      setShowModal(false);
      setSubscriptionToCancel(null);
      window.location.reload();

      // Check if there is content before parsing JSON
      let taskType = null;
      if (
        response.headers.get("content-length") !== "0" &&
        response.headers.get("content-type")?.includes("application/json")
      ) {
        taskType = await response.json();
      }
      return taskType;
    } catch (err) {
      toast.error("Something went wrong, Please try again later");
      navigate('/error');
      setLoading(false)
    }
  };

  const fetchBillingData = async () => {
    try {
      setLoading(true)
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/facility/${facilityId}/billing-portal/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            session_id: session_id,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch billing portal data");
      }

      const data = await response.json();
    } catch (error) {
      console.error("Error fetching billing portal:", error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    if (session_id && facilityId) {
      fetchBillingData()
    }
  }, [facilityId])

  const onClose = () => {
    setIsOpen(false)
  }

  const handleOpenQuestionModal = () => {
    setIsOpen(true)
    setShowModal(false);
  }
  return (
    <Master>
      <div className=''>
        {loading && (
          <div className="overlay">
            <div className="loader-wrapper">
              <Loader height={120} width={120} />
            </div>
          </div>
        )}
        <ToastContainer />
        <style>
          {`
          @media (min-width: 1200px) {
            .col-xs-6.col-md-2 {
              width: 50% !important;
            }
          }
        `}
        </style>

        {/* Subscription Cancellation Info Banner */}
        <div className="bg-red-100 border-l-8 border-red-600 p-6 mb-4 mx-8 mt-8 rounded-lg shadow-lg">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <i className="fa-solid fa-triangle-exclamation text-red-600 text-3xl"></i>
            </div>
            <div className="ml-4">
              <h3 className="text-2xl font-bold text-red-900 m-0 uppercase tracking-wide">Important Cancellation Notice</h3>
              <div className="mt-2 text-xl font-medium text-red-800">
                <p className="m-0 leading-relaxed">
                  Please note that all subscription cancellations require a review. You must submit a cancellation request to our support team, and your subscription will be officially canceled once the request is reviewed and processed.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center bg-gray-50 p-8">
          <section className="w-full bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
            {/* Header */}
            <div className="flex items-center lg:justify-between justify-start  border-b border-gray-200 pb-4 mb-8">
              <div className='flex items-center gap-3'>
                <i className="fa-solid fa-house"></i>
                <h2 className="text-4xl font-bold text-gray-800 m-0">
                  Resident Subscription
                </h2>
              </div>
              <div className='flex lg:flex-row flex-col items-center gap-2'>
                <button
                  className={`px-4 py-2 rounded-full text-2xl font-medium ${getStatusDetails(
                    residentStatus
                  ).className}`}
                  disabled
                >
                  {getStatusDetails(residentStatus).label}
                </button>

              </div>
            </div>

            {residentBillingInterval &&
              residentBillingInterval.plan.module === "resident" ? (
              <div className="flex lg:flex-row md:flex-row flex-col items-center justify-between">
                {/* Left Column – Subscription Info */}
                <div className="space-y-6">
                  <div className='flex flex-col gap-3'>
                    <p className="text-gray-500 text-3xl m-0">Subscription type</p>
                    <p className="text-gray-800 font-semibold text-3xl m-0">
                      {residentBillingInterval.plan.name} –{" "}
                      {residentBillingInterval.interval_count}{" "}
                      {residentBillingInterval.interval}
                    </p>
                  </div>



                  <div className='flex items-center mb-2'>
                    <p className="text-blue-800 font-medium m-0 text-2xl bg-blue-200 rounded-full py-2 px-3">
                      {residentCurrentPeriodEnd
                        ? `Next payment will automatically occur on ${new Date(
                          residentCurrentPeriodEnd
                        ).toLocaleDateString()}`
                        : "Next payment will automatically occur"}
                    </p>
                  </div>
                </div>

                {/* Right Column – Action Buttons */}
                {residentStatus !== 'past_due' ? (
                  <div className="flex flex-col lg:flex-row items-center gap-3  lg:justify-end justify-start ">
                    <Link
                      to={`/upgrade-subscription?billing_interval_id=${residentBillingInterval?.id}`}
                      className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 hover:!text-white transition"
                    >
                      <i className="fa-solid fa-arrow-up-from-bracket"></i>
                      Upgrade Subscription
                    </Link>

                    <button
                      onClick={() => cancelSubscription(resident)}
                      className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                    >
                      <i className="fa-solid fa-circle-xmark"></i>
                      Cancel Subscription
                    </button>

                    <a
                      href={`${process.env.REACT_APP_API_BASE_URL}/business_agreements/${agreementId}/download/?api_key=${token}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-blue-600 text-white hover:bg-blue-700 hover:!text-white transition"
                    >
                      <i className="fa-solid fa-file-import"></i>
                      Print Business Agreement
                    </a>

                    <button
                      onClick={() =>
                        handleChangeCardDetails(residentSubscriptionsId)
                      }
                      className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-purple-600 text-white hover:bg-purple-700 transition"
                    >
                      <i className="fa-solid fa-credit-card"></i>
                      Change Card Details
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() =>
                      navigate('/billing')
                    }
                    className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-yellow-600 text-white hover:bg-yellow-700 transition"
                  >
                    <i className="fa-solid fa-credit-card"></i>
                    Renew Now
                  </button>
                )}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center space-y-6 py-10">
                <a
                  href="/subscription"
                  target="_blank"
                  className="flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 hover:!text-white transition"
                >
                  {/* <FontAwesomeIcon icon={faPlus} /> */}
                  Subscribe Now
                </a>
                <p className="text-gray-600 text-lg font-medium text-center">
                  There aren't any subscriptions for this account
                </p>
              </div>
            )}
          </section>
        </div>
        <div className="flex items-center justify-center bg-gray-50 p-8">
          <section className="w-full  bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
            {/* Header */}
            <div className="flex items-center lg:justify-between justify-start  border-b border-gray-200 pb-4 mb-8">
              <div className='flex items-center gap-3'>
                <i className="fa-solid fa-clipboard-user text-3xl"></i>
                <h2 className="text-4xl font-bold text-gray-800 m-0">
                  STAFF SUBSCRIPTION
                </h2>
              </div>
              <div className='flex lg:flex-row flex-col items-center gap-2'>
                <button
                  className={`px-4 py-2 rounded-full text-2xl font-medium ${getStatusDetails(
                    staffStatus
                  ).className}`}
                  disabled
                >
                  {getStatusDetails(staffStatus).label}
                </button>

              </div>
            </div>
            {staffSubscription?.status === 'trialing' && !staffSubscription?.has_stripe_id && (

              <div className='flex items-center lg:justify-end justify-start'>
                <p className='bg-teal-200 text-teal-600 px-3 py-1 rounded-lg m-0'>Your credit card will be charged when the 30-day trial ends. You may cancel at any time.</p>
              </div>
            )}
            {staffBillingInterval &&
              staffBillingInterval.plan.module === "staff" ? (
              <div className="flex lg:flex-row md:flex-row flex-col items-center justify-between">
                {/* Left Column – Subscription Info */}
                <div className="space-y-6">
                  <div className='flex flex-col gap-3'>
                    <p className="text-gray-500 text-3xl m-0">Subscription type</p>
                    <p className="text-gray-800 font-semibold text-3xl m-0">
                      {staffBillingInterval.plan.name} - {staffBillingInterval.interval_count} {staffBillingInterval.interval}
                    </p>
                  </div>
                  <div className='flex items-center mb-2'>
                    <p className="text-blue-800 font-medium m-0 text-2xl bg-blue-200 rounded-full py-2 px-3">
                      {staffSubscription?.status === "trialing" && staffTrialPeriodEnd
                        ? `Your trial ends on ${new Date(staffTrialPeriodEnd).toLocaleDateString()}`
                        : staffCurrentPeriodEnd
                          ? `Next payment will automatically occur on ${new Date(staffCurrentPeriodEnd).toLocaleDateString()}`
                          : "Next payment date is unavailable."
                      }
                    </p>
                  </div>
                </div>

                {/* Right Column – Action Buttons */}
                <div className="flex flex-col lg:flex-row items-center gap-3  lg:justify-end justify-start ">
                  {staffStatus !== 'past_due' ? (
                    <>
                      {staffSubscription?.status === 'trialing' && !staffSubscription?.has_stripe_id && (
                        <button className='flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition' onClick={() => navigate('/subscription-staff?updateTrial=true')} // Query Params पास करें
                        >
                          Add Credit Card
                        </button>
                      )}
                      <button
                        onClick={() => cancelSubscription(staff)}
                        className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                      >
                        <i className="fa-solid fa-circle-xmark"></i>
                        Cancel Subscription
                      </button>
                      <button
                        onClick={() =>
                          handleChangeCardDetails(staffSubscriptionsId)
                        }
                        className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-purple-600 text-white hover:bg-purple-700 transition"
                      >
                        <i className="fa-solid fa-credit-card"></i>
                        Change Card Details
                      </button>
                    </>
                  ) : (
                    <button
                      onClick={() =>
                        navigate('/billing')
                      }
                      className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-yellow-600 text-white hover:bg-yellow-700 transition"
                    >
                      <i className="fa-solid fa-credit-card"></i>
                      Renew Now
                    </button>
                  )}

                </div>

              </div>
            ) : (
              <div className="flex flex-col items-center justify-center space-y-6 py-10">
                <a
                  href="/subscription-staff"
                  target="_blank"
                  className="flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 hover:!text-white transition"
                >
                  {/* <FontAwesomeIcon icon={faPlus} /> */}
                  Subscribe Now
                </a>
                <p className="text-gray-600 text-lg font-medium text-center">
                  There aren't any subscriptions for this account
                </p>
              </div>
            )}
          </section>
        </div>
        {/* <div className="flex items-center justify-center bg-gray-50 p-8">
          <section className="w-full  bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
            <div className="flex items-center lg:justify-between justify-start  border-b border-gray-200 pb-4 mb-8">
              <div className='flex items-center gap-3'>
                <i className="fa-solid fa-bag-shopping text-3xl"></i>
                <h2 className="text-4xl font-bold text-gray-800 m-0">
                  TRAINING SUBSCRIPTION
                </h2>
              </div>
              <div className='flex lg:flex-row flex-col items-center gap-2'>
                <button
                  className={`px-4 py-2 rounded-full text-2xl font-medium ${getStatusDetails(
                    trainingStatus
                  ).className}`}
                  disabled
                >
                  {getStatusDetails(trainingStatus).label}
                </button>

              </div>
            </div>
            {trainingBillingInterval &&
              trainingBillingInterval.plan.module === "trainings" ? (
              <div className="flex lg:flex-row md:flex-row flex-col items-center justify-between">
                <div className="space-y-6">
                  <div className='flex flex-col gap-3'>
                    <p className="text-gray-500 text-3xl m-0">Subscription type</p>
                    <p className="text-gray-800 font-semibold text-3xl m-0">
                      {trainingBillingInterval.plan.name} - {trainingBillingInterval.interval_count} {trainingBillingInterval.interval}
                    </p>
                  </div>

                </div>

                <div className="flex flex-col lg:flex-row items-center gap-3  lg:justify-end justify-start ">
                  {trainingStatus !== 'past_due' ? (
                    <>
                      <button
                        onClick={() => cancelSubscription(training)}
                        className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                      >
                        <i className="fa-solid fa-circle-xmark"></i>
                        Cancel Subscription
                      </button>
                      <button
                        onClick={() =>
                          handleChangeCardDetails(trainingSubscriptionsId)
                        }
                        className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-purple-600 text-white hover:bg-purple-700 transition"
                      >
                        <i className="fa-solid fa-credit-card"></i>
                        Change Card Details
                      </button>

                    </>) : (
                    <button
                      onClick={() =>
                        navigate('/billing')
                      }
                      className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-yellow-600 text-white hover:bg-yellow-700 transition"
                    >
                      <i className="fa-solid fa-credit-card"></i>
                      Renew Now
                    </button>
                  )}
                </div>

              </div>
            ) : (
              facilitydata?.sponsored_access && facilitydata?.opted_in_sponsorship_date ? (
                <div className='panel-body'>
                  <div className='form-group'>
                    <div className='col-xs-6 col-md-2'>
                      <label className='resident-label'>Subscription type:</label>
                    </div>
                    <div className='col-xs-6 col-md-3'>
                      <em className='resident-label'>Sponsored</em>
                    </div>
                  </div>

                  <div className='form-group'>
                    <div className='col-xs-6 col-md-2'>
                      <label className='resident-label'>Subscription status:</label>
                    </div>
                    <div className='col-xs-6 col-md-2'>
                      <button className="btn btn-success" disabled>
                        Opted-in
                      </button>
                    </div>
                  </div>

                  <div className='row'></div>
                  <div className='form-group'>
                    <div className="col-md-12 p-4">
                      <h4>Your subscription is free thanks to our sponsors!</h4>
                    </div>
                  </div>
                </div>
              ) : (
                !facilitydata?.has_active_non_trail_subscription ? (

                  <div className='panel-body'>
                    
                    <div className='form-group'>
                      <div className='col-md-12 p-4'>
                        <h3>To receive access to ALF Boss Trainings you need an paid / active Staff Plus subscription.</h3>
                      </div>
                    </div>
                  </div>

                ) : (
                  <div className="flex flex-col items-center justify-center space-y-6 py-10">
                    <a
                      href="/sponsorship"
                      target="_blank"
                      className="flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 transition"
                    >
                      Find out more!
                    </a>
                    <p className="text-gray-600 text-lg font-medium text-center">
                      Opt-in to receive FREE sponsored access to the new ALF Boss Trainings App There aren't any subscriptions for this account
                    </p>
                  </div>
                ))
            )}
          </section>
        </div> */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal-dialog delete" ng-class="{'modal-sm': size == 'sm', 'modal-lg': size == 'lg'}"><div class="modal-content" modal-transclude=""><div class="modal-header ng-scope">
              <h4>Confirm Action</h4>
            </div>
              <div className="modal-body ng-scope delete">
                <div className="row">
                  <div className="col-md-12">
                    <p className="ng-binding">Are you sure you want to cancel this subscription?</p>
                  </div>
                </div>
              </div>
              <div className="modal-footer ng-scope delete">
                <button className="btn btn-primary yes" onClick={() => handleOpenQuestionModal()} fdprocessedid="ao2s58">Yes
                </button><button className="btn btn-warning no" onClick={closeModal} fdprocessedid="i51p8i">No</button>
              </div>
            </div></div>
          </div>
        )}

        {showCardModal && (
          <div className="custom-modal-overlay">
            <div className="custom-modal">
              <div className="cardheader modal-header">
                <h4>Update Card Details</h4>
                <button className="cardclosecross" onClick={() => setShowCardModal(false)}>&times;</button>
              </div>
              <div className="modal-body">
                <Elements stripe={stripePromise}>
                  <CardUpdateForm
                    closeModal={() => setShowCardModal(false)}
                    facilityId={facilityId}
                    subscriptionId={subscriptionId} // Pass subscriptionId here
                  />
                  {/* <CardUpdateForm subscriptionId={subscriptionId} planId={planId} /> */}
                </Elements>
              </div>
              <div className="modal-footer">
                <button className="cardclose btn btn-danger" onClick={() => setShowCardModal(false)}>Close</button>
              </div>
            </div>
          </div>
        )}

      </div>
      {cancelProcessModal && (
        <div className="fixed  inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl p-8 text-center animate-fadeIn">

            {/* Icon */}
            {/* <div className="flex justify-center mb-4"> */}
            <CheckCircle className="text-emerald-600" style={{ width: "50px", height: "50px" }} />
            {/* </div> */}

            {/* Title */}
            <h2 className="text-4xl font-semibold text-gray-800 mb-2">
              Cancellation Request Submitted
            </h2>

            {/* Description */}
            <p className="text-gray-600 leading-relaxed text-2xl mb-6">
              Your cancellation request is currently being processed.
              Our support team will review it and get in touch with you shortly
              to assist you.
            </p>

            {/* Button */}
            <button
              onClick={() => setCancelProcessModal(false)}
              className="w-full py-3 rounded-xl bg-emerald-600 text-white font-medium hover:bg-emerald-700 transition text-2xl"
            >
              Okay, Got It
            </button>
          </div>
        </div>
      )}
      {isOpen && <CancelSubscriptionReviews isOpen={isOpen} onClose={onClose} onSubmit={confirmCancelSubscription} subscriptionToCancel={subscriptionToCancel} facilityId={facilityId} setLoading={setLoading} setCancelProcessModal={setCancelProcessModal} />}
    </Master>
  );
};

export default SubscriptionContent;